import { useId } from "react";
import { useTranslation } from "@ferrivia/i18n";
import { RadioChip } from "@ferrivia/ui";
import s from "./ChoiceGroup.module.css";

export interface BooleanQuestionProps {
  labelledBy: string;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
}

/** Kyllä/Ei as a two-chip radiogroup -- never a single toggle switch, so a
    screen reader hears "one of two" and an unanswered boolean is
    distinguishable from an answered "Ei" (a switch's off state can't tell
    the two apart). */
export function BooleanQuestion({ labelledBy, value, onChange }: BooleanQuestionProps) {
  const { t } = useTranslation("client");
  const name = useId();
  return (
    <div role="radiogroup" aria-labelledby={labelledBy} className={s.chips}>
      <RadioChip name={name} className={s.chip} checked={value === true} onChange={() => onChange(true)}>
        {t("questionnaire.yes", "Kyllä")}
      </RadioChip>
      <RadioChip name={name} className={s.chip} checked={value === false} onChange={() => onChange(false)}>
        {t("questionnaire.no", "Ei")}
      </RadioChip>
    </div>
  );
}
